// extracted by mini-css-extract-plugin
module.exports = {"list":"ContentList_list__27H8c"};